/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import React from "react";
import dynamic from "next/dynamic";
import cx from "classnames";

const AppHeader = dynamic(() => import("components/AppHeader/AppHeader"));

const AppFooterDesktop = dynamic(
  () => import("components/AppFooter/AppFooterDesktop")
);

import layoutStyles from "../Layout/Layout.module.scss";
import styles from "./LoginLayout.module.scss";

import { IConfigurationModel } from "@nf/common";

interface LoginLayoutProps {
  children: React.ReactNode;
  config: IConfigurationModel;
}

const LoginLayout = ({ children, config }: LoginLayoutProps) => {
  return (
    <div className={cx(layoutStyles.container, styles.layout)}>
      <AppHeader
        navigation={{
          visibility: {
            phone: false,
            tablet: false,
            desktop: true,
            large: true,
          },
          logo: { show: true },
        }}
        configuration={config}
      />

      <section>{children}</section>

      <AppFooterDesktop configuration={config} />
    </div>
  );
};

export default LoginLayout;
